import { isNumber } from 'lodash';
import { SliderInput } from '@meitu/saas-ui';
import { type VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@/components/label-action';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

export const BlurController: React.FC<Props> = ({ layerId, recordId }) => {
    const { $t } = useLocaleStore();

    const editor = useEditor();
    const blur = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return 0;

        const layerData = layer.data as IVectorLayerProps;
        return layerData.blur;
    }) as number;

    const setBlur = (value: number, options = { writeHistory: true }) => {
        if (!isNumber(value)) return;

        editor.getInstance<VectorLayer>('VectorLayer').setBlur(layerId, value, options);

        if (options.writeHistory) {
            Tracker.setBlur({
                recordId,
                stageType: editor.services.editor.getCanvasType(),
            });
        }
    };

    return (
        <div className="vector-panel-controller">
            <LabelAction title={$t((v) => v.panel.vectorPanel.blur)} align>
                <div style={{ width: 174 }}>
                    <SliderInput
                        min={0}
                        max={100}
                        value={blur}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(value) => setBlur(value, { writeHistory: false })}
                        onAfterChange={(value) => setBlur(value, { writeHistory: true })}
                    />
                </div>
            </LabelAction>
        </div>
    );
};
